import { motocaddyBackendPortalRequest } from "../apiConfig";
import { MCMemberDetails, MCMemberList, MCMemberPasswordUpdate, MCMemberProductDetails, MCMemberProductUpdate, MCMemberUpdate } from "../apiRequest";

  export const GetMCMemeberList  = async (searchParameter,user) => {
    const res = await motocaddyBackendPortalRequest(MCMemberList,searchParameter,user );
    return res.data;
  };

  export const GetMCMemeberDetails = async (id,user) => {
    const res = await motocaddyBackendPortalRequest(MCMemberDetails,id,user );
    return res.data;
  };

  export const UpdateMCMemberDetails = async (body,user) => {
    const res = await motocaddyBackendPortalRequest(MCMemberUpdate,body,user );
    return res.data;
  };

  export const UpdateMCMemberPassword = async (body,user) => {
    const res = await motocaddyBackendPortalRequest(MCMemberPasswordUpdate,body,user );
    return res.data;
  };

  export const GetMCMemberProductDetails = async (id,user) => {
    const res = await motocaddyBackendPortalRequest(MCMemberProductDetails,id,user );
    return res.data;
  };

  export const UpdateMCMemberProduct = async (body,user) => {
    const res = await motocaddyBackendPortalRequest(MCMemberProductUpdate,body,user );
    return res.data;
  };